import { render, staticRenderFns } from "./all-activities.vue?vue&type=template&id=cb4c9358&scoped=true&"
import script from "./all-activities.vue?vue&type=script&lang=js&"
export * from "./all-activities.vue?vue&type=script&lang=js&"
import style0 from "./all-activities.vue?vue&type=style&index=0&id=cb4c9358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4c9358",
  null
  
)

export default component.exports